import { api } from "@/lib/api";

// First-party lightweight analytics. Fire-and-forget event capture.
function getSessionId() {
  let sid = localStorage.getItem("stupeco_sid");
  if (!sid) {
    sid = `s_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 10)}`;
    localStorage.setItem("stupeco_sid", sid);
  }
  return sid;
}

export function track(name, props = {}) {
  try {
    api
      .post("/events", {
        name,
        path: window.location.pathname,
        session_id: getSessionId(),
        props,
      })
      .catch(() => {});
  } catch {
    /* never block UX for analytics */
  }
}

// Track scroll depth milestones once per page load.
export function initScrollDepth() {
  const milestones = [25, 50, 75, 100];
  const fired = new Set();
  const onScroll = () => {
    const scrolled = window.scrollY + window.innerHeight;
    const height = document.body.scrollHeight;
    const pct = Math.min(100, Math.round((scrolled / height) * 100));
    milestones.forEach((m) => {
      if (pct >= m && !fired.has(m)) {
        fired.add(m);
        track("scroll_depth", { depth: m });
      }
    });
    if (fired.size === milestones.length) window.removeEventListener("scroll", onScroll);
  };
  window.addEventListener("scroll", onScroll, { passive: true });
  return () => window.removeEventListener("scroll", onScroll);
}
